import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {userVerifyActions} from "./userVerifySlice";
import {userApi} from "~/api";

function* fetchDemoList(action) {
	try {
		const response = yield call(userApi.gets, action.payload);
		yield put(userVerifyActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch userVerify list', error);
		let message = error.message;
		if(error?.response?.data?.message) message = error.response.data.message;
		yield put(userVerifyActions.fetchDataFailed(message));
	}
}

function* handleSearchDebounce(action) {
	yield put(userVerifyActions.setFilter(action.payload));
}

export default function* userVerifySaga() {
	yield takeLatest(userVerifyActions.fetchData.type, fetchDemoList);
	yield debounce(500, userVerifyActions.setFilterWithDebounce.type, handleSearchDebounce)
}